// extracted by mini-css-extract-plugin
export default {"UpdateBackupSettings":"UpdateBackupSettings_UpdateBackupSettings__doUHB","form":"UpdateBackupSettings_form__KY-Tr"};